import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { ComponentPropsWithoutRef } from 'react';

interface IProps extends ComponentPropsWithoutRef<typeof Avatar> {
  walletAddress: string;
}
export default (props: IProps) => {
  const { walletAddress, ...attr } = props;

  function findFirstDigit(str: string) {
    if (!str) return 0;
    const match = str?.match(/\d/);
    return match ? match[0] : null;
  }

  return (
    <Avatar {...attr}>
      <AvatarImage src={`/avatar/avatar_0${findFirstDigit(walletAddress)}.png`} />
      <AvatarFallback delayMs={1000}>{walletAddress?.slice(0, 2).toUpperCase()}</AvatarFallback>
    </Avatar>
  );
};
